import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { submitContactForm } from '../../api/services/contactService';

// Async thunk
export const submitContactFormAction = createAsyncThunk(
  'contact/submitForm',
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await submitContactForm(contactData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to submit contact form');
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  success: false,
  error: null,
};

// Slice
const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearContactState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Submit Contact Form
      .addCase(submitContactFormAction.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitContactFormAction.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(submitContactFormAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { clearContactState } = contactSlice.actions;
export default contactSlice.reducer;